import React, {useState,useEffect} from 'react';
// import { Authenticator } from 'aws-amplify-react';
import Amplify, {Auth,Hub} from 'aws-amplify';
import ReactDOM from 'react-dom';
import awsmobile from '../../aws-exports';
import Theme from '../Theme/Theme';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {UserData, ProgressesStatus, ThemeContext} from '../../context';

import Login from '../Login/Login';
import BackendConfig from '../../stacks/config/ConfigAWS'
// ICA
import InfoNeededScreen from '../InfoNeededScreen/InfoNeededScreen';
import CompanyScreen from '../CompanyScreen/CompanyScreen';
import FAQScreen from '../FAQScreen/FAQScreen';
import ICAGlossaryScreen from '../ICAGlossaryScreen/ICAGlossaryScreen';
import Progress from '../../stacks/progress/ProgressAWS';
import ProgressScreen from '../ProgressScreen/ProgressScreen';
import QuestionnaireICAScreen from '../QuestionnaireICAScreen/QuestionnaireICAScreen';
import QuestionnaireStratPlanScreen from '../QuestionnaireStratPlanScreen/QuestionnaireStratPlanScreen';
import ReportScreenNew from '../ReportScreen/ReportScreenNew';
import UploadScreen from '../UploadScreen/UploadScreen'
//Strat Plan
import FinancialModelScreen from '../FinancialModelScreen/FinancialModelScreen'
import FinancialGlossaryScreen from '../FinancialGlossaryScreen/FinancialGlossaryScreen';
// Portal
import PortalHomeScreen from '../Portal/PortalHomeScreen/PortalHomeScreen'
import PortalContentScreen from '../PortalContentScreen/PortalContentScreen'
import PortalGlossaryScreen from '../PortalGlossaryScreen/PortalGlossaryScreen';
import PortalMessageScreen from '../PortalMessageScreen/PortalMessageScreen'
import PortalRecentMessageScreen from '../PortalRecentMessageScreen/PortalRecentMessageScreen'
import PortalSearchCriteriaScreen from '../PortalSearchCriteriaScreen/PortalSearchCriteriaScreen'
import PortalSearchSOFScreen from '../PortalSearchSOFScreen/PortalSearchSOFScreen'
import PortalUploadScreen from '../PortalUploadScreen/PortalUploadScreen'
import PortalFAQScreen from '../PortalFAQScreen/PortalFAQScreen'
import DisclaimerScreen,{disclaimerVersion} from '../DisclaimerScreen/DisclaimerScreen'
import LoadingScreen from '../LoadingScreen/LoadingScreen'

Amplify.configure(awsmobile);

var globalProgressesTimer = undefined //TODO should be in context perhaps

function getProductAbbrev(productName) {
  switch (productName) {
  case 'client': return 'dp'
  case 'dreamportal': return 'sof'
  default:
  }
  throw new Error('Login product unknown')
}

function getRegURL() {
  let regURL = undefined
  const deliveryBucketParts = awsmobile.aws_content_delivery_bucket.split('-')
  const productName = deliveryBucketParts[0]
  const product = getProductAbbrev(productName)
  const env = deliveryBucketParts.pop()
  switch (env) {
    case 'test': regURL = `https://signup-test.dreamexcloud.com?product=${product}`; break;
    case 'prod': regURL = `https://signup.dreamexcloud.com?product=${product}`; break;
    default: regURL = `http://localhost:3002?product=${product}`; break;
  }
  return regURL
}

function getUserNameFromURL() {
  const url = new URL(document.location)
  return url.searchParams.get('user-name') || ''
}

const App = () => {
  const [user,setUser] = useState(null);
  const [theme, setTheme] = useState("light");
  const [progresses, setProgresses] = useState({
    company: 'unavailable',
    uploadFiles: 'unavailable',
    questionnaire: 'unavailable',
    report: 'unavailable',
    update: updateProgresses
  })
  const [phoneVerifReq,setPhoneVerifyReq] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(true)
  const [searchString, setSearchString] = useState('')

  const userName = getUserNameFromURL()

  const regURL = getRegURL()

  async function getPeriodicProgresses() {
    try {
      const progressApi = Progress.getInstance();
      const data = await progressApi.retrieve()
      // console.log(`INFO Report tick progresses ${JSON.stringify(data, null, 2)}`)
      if (data.report === 'completed') {
        // console.log(`INFO Report clearing interval id ${globalProgressesTimer}`)
        clearInterval(globalProgressesTimer)
        globalProgressesTimer = undefined
        const merged = Object.assign(progresses, data)
        setProgresses(merged)
        ReactDOM.render(<App />, document.getElementById('root'));
      }
    }
    catch (err) {
      console.error("APP gerPeriodicProgresses failed: ", err.message);      
    }
  }

  function updateSearchString(value) {
    setSearchString(value)
  }

  async function updateProgresses(updatedProgresses) {
    const merged = Object.assign(progresses, updatedProgresses)
    setProgresses(merged)

    if (progresses.questionnaire === 'completed'
     && progresses.report        === 'inProgress'
     && globalProgressesTimer                  === undefined) {
      globalProgressesTimer = setInterval(getPeriodicProgresses, 10000)
      // console.log(`INFO Report timer started ${globalProgressesTimer}`)
    }
  }

  useEffect(() => {

    async function getConfig() {
      try {
        const configAPI = BackendConfig.getInstance()

        const config = await configAPI.retrieve()

        const agree = config && config.progresses && config.progresses.disclaimerAgree === disclaimerVersion
        const dontShow = config && config.progresses && config.progresses.disclaimerDontShowAgain === 'true'

        if (agree && dontShow) {
          setShowDisclaimer(false)
        }
        return config
      }
      catch (error) {
        console.error(`ERROR getConfig ${error.message}`)
        return {env: 'error'}
      }
    }
  
    async function getUserData() {
        try {
          var userData = await Auth.currentAuthenticatedUser({bypassCache: true});
        } catch (err) {
          if (err !== 'not authenticated') {
            console.error(`getUserData ${err}`)
          }
          return
        }
        let userState = null;
        if (userData) {
          const config = await getConfig()
          userState = userData
          userState['config'] = config
        }
        setUser(userState);
    }
  
    function onHubCapsule(capsule) {
      switch(capsule.payload.event) {
        case 'signIn':
          getUserData();
          break;
        case 'signUp':
          getUserData();
          break;
        case 'signOut':
          setUser(null);
          break;
        default:
          return;
      }
    }
  
    getUserData();

    Hub.listen('auth', onHubCapsule);

    return () => {
      Hub.remove('auth', onHubCapsule);
    }
  },[]);

  useEffect(() => {
    async function getUserData() {
      try {
        const userData = await Auth.currentAuthenticatedUser({bypassCache: true});
        setUser({...user, ...userData})
      } catch (err) {
        if (err !== 'not authenticated') {
          console.log(`getUserData in emailVerifReq ${err}`)
        }
      }
    }
    getUserData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneVerifReq])


  useEffect(() => {
    async function getProgresses() {
      try {
        const progressApi = Progress.getInstance();
        const data = await progressApi.retrieve()
        updateProgresses(data)
        ReactDOM.render(<App />, document.getElementById('root'));
      }
      catch (err) {
        console.error("APP Progress retreive failed: ", err.message);
      }
    }
  
    if (user) {
      getProgresses()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user])

  
  useEffect(() => {
    if (user) {
      if (!user.attributes.phone_number_verified) {
        setPhoneVerifyReq(true);
      }
    }
  },[user])


  if (!user) {
    return <Login regURL={regURL} userName={userName}/>
  }

  // if (emailVerifReq) {
  //   return <VerifyEmail setEmailVerifReq={setEmailVerifReq} phone/>;
  // }

  if (!(user && user.config)) {
    return (
      <Router>
        <Route path='/'
          render={props => (
            <LoadingScreen/>
          )}
        />
      </Router>
    )
  }

  async function setDisclaimer(disclaimerAgreeValue, disclaimerDontShowAgain) {
    try {
      console.log(`Agree: ${disclaimerAgreeValue} Don't show again ${disclaimerDontShowAgain}`)
      const disclaimerAgree = disclaimerAgreeValue ? disclaimerVersion : false
      const progressApi = Progress.getInstance();
      await progressApi.store({disclaimerAgree, disclaimerDontShowAgain: disclaimerDontShowAgain ? 'true' : 'false'})
      if (disclaimerAgree) {
        setShowDisclaimer(false)
      }
    }
    catch (err) {
      console.error(`setDisclaimer ${err.message}`)
    }
  }

  if (showDisclaimer) {
    return (
      <Router>
        <Route path='/'
          render={props => (
            <DisclaimerScreen
            submit={setDisclaimer}/>
          )}
        />
      </Router>
    )
  }

  return (
    <UserData.Provider value={user}>
      <ProgressesStatus.Provider value={progresses}>
        <ThemeContext.Provider value={{ theme, setTheme }}>
          <Theme>
            <Router>
              <Route exact path='/' component={PortalHomeScreen} />
              <Route exact path='/progress' component={ProgressScreen} />
              <Route path='/company'
                render={props => (
                  <CompanyScreen
                    {...props}
                    product='ica'
                  />
                )}
              />
              <Route path='/company-stratplan'
                render={props => (
                  <CompanyScreen
                    {...props}
                    product='stratPlan'
                  />
                )}
              />
              <Route path='/questionnaire' component={QuestionnaireICAScreen} />
              <Route path='/questionnaire-stratplan' component={QuestionnaireStratPlanScreen} />
              <Route path='/report' component={ReportScreenNew} />
              <Route path='/faq' component={FAQScreen} />
              <Route path='/info' component={InfoNeededScreen} />
              <Route path='/ica-glossary' component={ICAGlossaryScreen} />
              <Route path='/financial-glossary' component={FinancialGlossaryScreen} />
              <Route path='/upload' component={UploadScreen} />
              <Route exact path='/financial' component={FinancialModelScreen} />
              <Route path='/portal' component={PortalHomeScreen} />
              <Route path='/content' component={PortalContentScreen} />
              <Route path='/criteria' component={PortalSearchCriteriaScreen} />
              <Route path='/search-sof'
                render={props => (
                  <PortalSearchSOFScreen
                    {...props}
                    updateSearchString={updateSearchString}
                    searchString={searchString}
                  />
                )}
              />
              <Route path='/portal-upload' component={PortalUploadScreen} />
              <Route path='/recent-messages' component={PortalRecentMessageScreen} />
              <Route path='/portal-message/:sofId' component={PortalMessageScreen} />
              <Route path='/portal-glossary' component={PortalGlossaryScreen} />
              <Route path='/portal-faq' component={PortalFAQScreen} />
            </Router>
          </Theme>
        </ThemeContext.Provider>
      </ProgressesStatus.Provider>
    </UserData.Provider>
  );
};

// export default withAuthenticator(App, false, [], null, theme);
export default App;
